import { isError } from 'lodash-es'

export function* iterateError(error?: unknown) {
	let current = error
	while (current !== undefined) {
		if (current instanceof AggregateError) {
			yield* current.errors
		} else {
			yield current
		}

		current = isError(current) ? current.cause : undefined
	}
}
